/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { UserRolesEnumType } from './UserRolesEnum'
import { RootStoreType } from './index'

/**
 * SetUserRolesResultBase
 * auto generated base class for the model SetUserRolesResultModel.
 */
export const SetUserRolesResultModelBase = ModelBase.named('SetUserRolesResult')
  .props({
    __typename: types.optional(types.literal('SetUserRolesResult'), 'SetUserRolesResult'),
    auth0Error: types.union(types.undefined, types.null, types.string),
    auth0Id: types.union(types.undefined, types.null, types.string),
    auth0Status: types.union(types.undefined, types.string),
    mongoStatus: types.union(types.undefined, types.string),
    previousRoles: types.union(types.undefined, types.array(UserRolesEnumType)),
    roles: types.union(types.undefined, types.array(UserRolesEnumType)),
    userId: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SetUserRolesResultModelSelector extends QueryBuilder {
  get auth0Error() {
    return this.__attr('auth0Error')
  }
  get auth0Id() {
    return this.__attr('auth0Id')
  }
  get auth0Status() {
    return this.__attr('auth0Status')
  }
  get mongoStatus() {
    return this.__attr('mongoStatus')
  }
  get previousRoles() {
    return this.__attr('previousRoles')
  }
  get roles() {
    return this.__attr('roles')
  }
  get userId() {
    return this.__attr('userId')
  }
}
export function selectFromSetUserRolesResult() {
  return new SetUserRolesResultModelSelector()
}

export const setUserRolesResultModelPrimitives =
  selectFromSetUserRolesResult().auth0Error.auth0Id.auth0Status.mongoStatus.previousRoles.roles.userId
